import React from 'react';
import { component_tool, framework_tool } from '@/tool'
import { WizClassifySelectRe, WizTableForm } from '@/containers/common'
import { Card,Form,Checkbox } from 'antd'
import '@/styles/containers/face/class/style.less';

let { WizButton, WizSelect, WizIcon, Wizmessage, WizDivider, WizRow, WizCol, WizRadio, WizTooltip, WizCheckbox,WizInput } = component_tool;
let { WizAvatarUpload, ossFileUtils } = framework_tool

let WizForm = Form
let Item = Form.Item

let Option = WizSelect.Option
let OptGroup = WizSelect.OptGroup
const surveyTempConfig = WizTableForm.Config.surveyTemp(this, { apiParams: { status: 1 } })

const offlineProgramConfig = WizTableForm.Config.offlineProgram(this, { apiParams: { status: 1 } });
const examTempConfig = WizTableForm.Config.examTemp(this, { apiParams: { state: 1 } });

const userConfigVideo = WizTableForm.Config.user(this, { apiParams: { status: 1, roleConfig: "teacherRole",isNotAuth: true} });
const userConfig = WizTableForm.Config.user(this, { apiParams: { status: 1, roleConfig: "teacherRole" } });
const userNevConfig = WizTableForm.Config.user(this, { apiParams: { status: 1, roleConfig: "teacherNevRole" } });
const homeworkConfig = WizTableForm.Config.homework(this, { apiParams: { state: 1 } });


/**
 * 直播
 */
export const columnsVideo = (self, data) => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      name: 'ownerId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      name: 'personIds',
      formItem: {
        type: 'hidden',
        initialValue: data && data['personIds'] ? data['personIds'] : null
      }
    },
    {
      name: 'aideTypeId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['aideTypeId'] ? data['aideTypeId'] : null
      }
    },
    {
      name: 'classId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['classId'] ? data['classId'] : null
      }
    },
    {
      name: 'classAideId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['classAideId'] ? data['classAideId'] : null
      }
    },
    {
      title: '直播类型',
      name: 'liveType',
      formItem: {
        type: 'hidden',
        initialValue: data && data['liveType'] ? data['liveType'] : null
      }
    },
    {
      title: "状态",
      name: "state",
      dict: [
        { code: 1, codeName: "草稿" },
        { code: 2, codeName: "预告中" },
        { code: 3, codeName: "直播中" },
        { code: 4, codeName: "已结束" }
      ],
      formItem: {
        type: 'hidden',
        initialValue: data && data['state'] ? data['state'] : 1,
      }
    },
    {
      title: '环节名称',
      name: 'name',
      formItem: {
        initialValue: data && data['name'] ? data['name'] : null,
        placeholder: '默认班级名称',
        rules: [{
          required: true,
          message: '请输入环节名称'
        }, {
          max: 30,
          message: '环节名称不能超过30个字'
        }
        ],
      }
    },
    {
      title: '直播分类',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form;
          let categoryInfo;
          if (record && record.liveCategoryId && record.categoryName) {
            categoryInfo = [{ key: record.liveCategoryId, title: record.categoryName }]
          }
          return (
            <div>
              {getFieldDecorator('liveCategoryId', {
                rules: [{ type: 'array' }, { required: true, message: '请选择直播分类' }],
                initialValue: record && record.liveCategoryId ? [record.liveCategoryId] : [],
              })(
                <WizClassifySelectRe
                  returnKey={true}
                  apiProps={{ type: 9, state: 1 }}
                  initSelects={categoryInfo ? categoryInfo : []}
                  wizTreeSelectListProps={{
                    itemProps: {
                      icon: 'unordered-list',
                      title: '直播分类',
                      tips: '请选择直播分类'
                    },
                    multiple: false,
                    treeCheckable: false,
                    checkable: false,
                    showSelectList: true,
                    treeProps: { checkStrictly: true }
                  }} />
              )}
            </div>
          );
        }
      }
    },
    {
      title: "讲师",
      name: "hostId",
      formItem: {
        ...userConfigVideo,
        diy: WizTableForm,
        initialValue: data && data['hostId'] ? data['hostId'] : '',
        title: "选择讲师",
        initRows: data && data['hostId'] && data['hostName'] ? [{
          key: '1',
          personId: data['hostId'],
          fullName: data['hostName'],
          id: data['hostId']
        }] : [],
        selectType: 'radio',
        rules: [{ required: true, message: '请选择讲师' }],
      },
    },
    // {
    //   title: "视频工具",
    //   name: "videoTool",
    //   dict: [
    //     { code: 1, codeName: "中目" },
    //     { code: 2, codeName: "慧课堂" },
    //   ],
    //   formItem: {
    //     type: "radio",
    //     initialValue: data && data['videoTool'] ? data['videoTool'] : 1,
    //     onChange: (form, value, label, extra) => {
    //       if(value==2){
    //         form.setFieldsValue({lookingBack:0})
    //       }
    //       self.setState({showHkt:value==2},()=>{
    //         let type = data.liveType === 5 ? 2 : 1;
    //         let meetingNo = data.ownerId;
    //         let videoTool = form.getFieldValue("videoTool");
    //         let classDate = form.getFieldValue("classDate");
    //         if(classDate && classDate.length==2){
    //           let startDate = classDate[0].format('YYYY-MM-DD HH:mm:ss')
    //           let endDate = classDate[1].format('YYYY-MM-DD HH:mm:ss')
    //           self.checkMeetingDate(startDate, endDate, meetingNo, type,videoTool)
    //         }
    //       });
    //     },
    //     disabled: data.videoTool && (data.videoTool==1|| data.videoTool==2),
    //   }
    // },
    !self.state.showHkt ?
    {
      title: '主讲人',
      name: 'speaker',
      formItem: {
        placeholder: '请输入主讲人',
        rules: [{
          max: 50,
          message: '输入主讲人姓名最多50字'
        }
        ],
      },
    }:{},
    {
      title: "是否可回看",
      name: "lookingBack",
      dict: [
        { code: 1, codeName: "是" },
        { code: 0, codeName: "否" },
      ],
      formItem: {
        type: "radio",
        initialValue: data && data['lookingBack'] ? data['lookingBack'] : 0,
        disabled : self.state.showHkt
      }
    },
    {
      title: '环节时间',
      name: 'classDate',
      formItem: {
        type: "date~",
        showTime: true,
        initialValue: data && data['classDate'] ? data['classDate'] : data.classAideDefaultDate,
        rules: [{
          required: true,
          message: '请选择环节时间'
        }],
        disabled: data && data['state'] && data['state'] !== 1,
        onChange: (form, value, label, extra) => {
          if (label && label.length > 0) {
            let startDate = label[0];
            let endDate = label[1];
            // type ： 0:zoom资源帐户；1：中目 远程评估资源帐户    2: 中目 直播课堂 远程认证
            // liveType： 5 直播课堂 6远程评估
            let type = data.liveType === 5 ? 2 : 1;
            let meetingNo = data.ownerId;
          //  let videoTool = form.getFieldValue("videoTool");
            let videoTool  = data.videoTool ? data.videoTool : 2
            self.checkMeetingDate(startDate, endDate, meetingNo, type,videoTool)
          }
        },
      },
    },
    self.state.checkDateInfo ?
      {
        title: <font style={{ 'color': 'red' }}>提醒</font>,
        name: "checkDateInfo",
        formItem: {
          type: self.state.checkDateInfo ? 'diy' : 'hidden',
          diy: () => {
            return (
              <div style={{ 'color': 'red' }}>{self.state.checkDateInfo}</div>
            )
          }
        },
      } : {},
    {
      title: '上传封面',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form;
          return (
            <div style={{ width: 400 }}>
              <>
                {getFieldDecorator('img', {
                  initialValue: (data && data.img) ? [
                    { fileId: data.img }
                  ] : [],
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={400 / 207}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 0.195;
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过200k!');
                      }
                      return isLt1M;
                    }}
                  />
                )}
              </>
            </div>
          )
        }
      }
    },
    {
      title: "状态",
      name: "status",
      dict: [
        { code: 0, codeName: "打开" },
        { code: 1, codeName: "关闭" }
      ],
      formItem: {
        // type: "radio",
        type: 'hidden',
        initialValue: data && data['status'] ? data['status'] : 0,
      }
    },
    {
      title: "环节阶段",
      name: "stage",
      dict: [
        { code: 0, codeName: "课前" },
        { code: 1, codeName: "课中" },
        { code: 2, codeName: "课后" }
      ],
      formItem: {
        type: "radio",
        initialValue: data && data['stage'] ? data['stage'] : 1,
      }
    },

    {
      formItem: {
        type: 'custom',
        col: { span: 24 },
        formItemLayout: {
          labelCol: { span: 0 },
          wrapperCol: { span: 24 }
        },
        render: (record, form) => {
          const { getFieldDecorator,getFieldValue } = form;
          return (
            self.state.showHkt?
            <>
                <WizDivider dashed className='divider-form-style' />
              <WizRow className='row-live-title-style' style={{ marginBottom: 24 }}>
                <WizCol span={4} className='ant-col ant-col-4 ant-form-item-label'>{'直播设置：'}</WizCol>
                <WizCol span={18} className='ant-col ant-col-17 ant-form-item-control-wrapper'>
                  {getFieldDecorator('interactLiveDefault', {})(
                    <WizButton title="恢复默认设置" size='small' onClick={e => {
                      self._changeInteractLiveValue(form)
                    }}>恢复默认设置</WizButton>
                  )}
                </WizCol>
              </WizRow>
              <Card id='classDefaultEdit'>
              <Item>
                  {getFieldDecorator('isHostCamera', {initialValue: data.isHostCamera ? [1] : [0]})(
                  <WizCheckbox.Group>
                    <WizCheckbox value={1}>主持人进课堂开启摄像头</WizCheckbox>
                  </WizCheckbox.Group>,)}
              </Item>
      <Item >
        {getFieldDecorator('isHostMic', {
          initialValue: data.isHostMic ?  [1] : [0]
        })(
          <WizCheckbox.Group>
            <WizCheckbox value={1}>主持人进课堂开启麦克风</WizCheckbox>
          </WizCheckbox.Group>,
        )}
      </Item>
      <Item >
        {getFieldDecorator('isParticipantPlatform', {
          initialValue: data.isParticipantPlatform ?  [1] : [0]
        })(
          <WizCheckbox.Group>
            <WizCheckbox value={1}>参与者进课堂时在讲台上</WizCheckbox>
          </WizCheckbox.Group>,
        )}
      </Item>
      {
        getFieldValue('isParticipantPlatform') && getFieldValue('isParticipantPlatform')[0] ? <>
        <Item >
        {getFieldDecorator('isAllowCamera', {
          initialValue: data.isAllowCamera ?  [1] : [0]
        })(
          <WizCheckbox.Group>
            <WizCheckbox value={1}>讲台上的参与者允许开启摄像头</WizCheckbox>
          </WizCheckbox.Group>,
        )}
      </Item>
      <Item >
        {getFieldDecorator('isParticipantCamera', {
          initialValue: data.isParticipantCamera ?  [1] : [0]
        })(
          <WizCheckbox.Group>
            <WizCheckbox value={1}>讲台上的参与者开启摄像头</WizCheckbox>
          </WizCheckbox.Group>,
        )}
      </Item>
      <Item >
        {getFieldDecorator('isAllowMic', {
          initialValue: data.isAllowMic ?  [1] : [0]
        })(
          <WizCheckbox.Group>
            <WizCheckbox value={1}>讲台上的参与者允许开启麦克风</WizCheckbox>
          </WizCheckbox.Group>,
        )}
      </Item>
      <Item>
        {getFieldDecorator('isParticipantMic', {
          initialValue: data.isParticipantMic ?  [1] : [0]
        })(
          <WizCheckbox.Group>
            <WizCheckbox value={1}>讲台上的参与者开启麦克风</WizCheckbox>
          </WizCheckbox.Group>,
        )}
      </Item>
      </>
        :null
      }

      <Item >
        {getFieldDecorator('isFollowHost', {
          initialValue: data.isFollowHost ?  [1] : [0]
        })(
          <WizCheckbox.Group>
            <WizCheckbox value={1}>所有人跟随主持人</WizCheckbox>
          </WizCheckbox.Group>,
        )}
      </Item>
              </Card>
            </>
            :
            <>
              <WizDivider dashed className='divider-form-style' />
              <WizRow className='row-live-title-style' style={{ marginBottom: 24 }}>
                <WizCol span={4} className='ant-col ant-col-4 ant-form-item-label'>{'直播设置：'}</WizCol>
                <WizCol span={18} className='ant-col ant-col-17 ant-form-item-control-wrapper'>
                  {getFieldDecorator('interactLiveDefault', {})(
                    <WizButton title="恢复默认设置" size='small' onClick={e => {
                      self._changeInteractLiveValue(form)
                    }}>恢复默认设置</WizButton>
                  )}
                </WizCol>
              </WizRow>
              <Card>
                <WizRow className='row-live-form-style' style={{ marginTop: 10, marginBottom: 10 }}>
                  <WizCol span={5} className='item-form-title' style={{ textAlign: 'right' }}>{'是否自动录制：'}</WizCol>
                  <WizCol span={6} className='item-content'>
                    {getFieldDecorator('autoRecording', {
                      initialValue: data && data['autoRecording'] ? data['autoRecording'] : 0
                    })(
                      <WizRadio.Group>
                        <WizRadio value={1}>是</WizRadio>
                        <WizRadio value={0}>否</WizRadio>
                      </WizRadio.Group>
                    )}
                    <WizTooltip title="是否系统自动录制视频">
                      <WizIcon type="question-circle-o" />
                    </WizTooltip>
                  </WizCol>
                  <WizCol span={6} className='item-form-title' style={{ textAlign: 'right' }}
                    offset={1}>{'讲师视频：'}</WizCol>
                  <WizCol span={6} className='ant-col ant-col-17 ant-form-item-control-wrapper item-content'>
                    {getFieldDecorator('hostVideo', {
                      initialValue: data && data['hostVideo'] ? data['hostVideo'] : 0
                    })(
                      <WizRadio.Group>
                        <WizRadio value={1}>是</WizRadio>
                        <WizRadio value={0}>否</WizRadio>
                      </WizRadio.Group>
                    )}
                    <WizTooltip title="讲师进入课堂时是否打开摄像头">
                      <WizIcon type="question-circle-o" />
                    </WizTooltip>
                  </WizCol>
                </WizRow>
                <WizRow className='row-live-form-style' style={{ marginTop: 10, marginBottom: 10 }}>
                  <WizCol span={5} className='item-form-title' style={{ textAlign: 'right' }}>{'学员视频：'}</WizCol>
                  <WizCol span={6} className='ant-col ant-col-17 ant-form-item-control-wrapper item-content'>
                    {getFieldDecorator('participantVideo', {
                      initialValue: data && data['participantVideo'] ? data['participantVideo'] : 0
                    })(
                      <WizRadio.Group>
                        <WizRadio value={1}>是</WizRadio>
                        <WizRadio value={0}>否</WizRadio>
                      </WizRadio.Group>
                    )}
                    <WizTooltip title="学员进入课堂时是否打开摄像头">
                      <WizIcon type="question-circle-o" />
                    </WizTooltip>
                  </WizCol>
                  <WizCol span={6} className='item-form-title' style={{ textAlign: 'right' }}
                    offset={1}>{'是否开启等候室：'}</WizCol>
                  <WizCol span={6} className='ant-col ant-col-17 ant-form-item-control-wrapper item-content'>
                    {getFieldDecorator('waitingRoom', {
                      initialValue: data && data['waitingRoom'] ? data['waitingRoom'] : 0
                    })(
                      <WizRadio.Group>
                        <WizRadio value={1}>是</WizRadio>
                        <WizRadio value={0}>否</WizRadio>
                      </WizRadio.Group>
                    )}
                    <WizTooltip title="等候室,学员进入课堂时，将他们放在等候室中，并要求讲师单独接受。启用等候室会自动禁用允许学员先进入课堂的设置">
                      <WizIcon type="question-circle-o" />
                    </WizTooltip>
                  </WizCol>
                </WizRow>
                <WizRow className='row-live-form-style' style={{ marginTop: 10, marginBottom: 10 }}>
                  <WizCol span={5} className='item-form-title' style={{ textAlign: 'right' }}>{'进入静音：'}</WizCol>
                  <WizCol span={6} className='ant-col ant-col-17 ant-form-item-control-wrapper item-content'>
                    {getFieldDecorator('muteUponEntry', {
                      initialValue: data && data['muteUponEntry'] ? data['muteUponEntry'] : 0
                    })(
                      <WizRadio.Group>
                        <WizRadio value={1}>是</WizRadio>
                        <WizRadio value={0}>否</WizRadio>
                      </WizRadio.Group>
                    )}
                    <WizTooltip title="学员进入课堂时是否默认静音">
                      <WizIcon type="question-circle-o" />
                    </WizTooltip>
                  </WizCol>
                  <WizCol span={6} className='item-form-title' style={{ textAlign: 'right' }}
                    offset={1}>{'学员先进入课堂：'}</WizCol>
                  <WizCol span={6} className='ant-col ant-col-17 ant-form-item-control-wrapper item-content'>
                    {getFieldDecorator('joinBeforeHost', {
                      initialValue: data && data['joinBeforeHost'] ? data['joinBeforeHost'] : 0
                    })(
                      <WizRadio.Group>
                        <WizRadio value={1}>是</WizRadio>
                        <WizRadio value={0}>否</WizRadio>
                      </WizRadio.Group>
                    )}
                    <WizTooltip title="当老师未进入课堂时,是否允许学员先进入">
                      <WizIcon type="question-circle-o" />
                    </WizTooltip>
                  </WizCol>
                </WizRow>
              </Card>
            </>
          )
        }
      }
    },
  ]
};
/**
 * 问卷
 */
export const columnsQuestionnaire = (self, data) => {
  const surveyTempConfig = WizTableForm.Config.surveyTemp(self, { apiParams: { status: 1 } })
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      name: 'aideTypeId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['aideTypeId'] ? data['aideTypeId'] : null
      }
    },
    {
      name: 'classId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['classId'] ? data['classId'] : null
      }
    },
    {
      name: 'classAideId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['classAideId'] ? data['classAideId'] : null
      }
    },
    {
      title: '环节名称',
      name: 'name',
      formItem: {
        initialValue: data && data['title'] ? data['title'] : null,
        rules: [{
          required: true,
          message: '请输入环节名称'
        }, {
          max: 30,
          message: '环节名称不能超过30个字'
        }
        ],
      }
    },
    !data.entityRecord ?
      {
        title: "选择问卷模版",
        name: "questionnaireId",
        formItem: {
          ...surveyTempConfig,
          diy: WizTableForm,
          initRows: [],
          selectType: 'radio',
          rules: [{
            required: true,
            message: '请选择问卷模版',
          }]
        },
      } : {},
    data.entityRecord ?
      {
        title: '选择问卷模版',
        name: 'surveyTemplateName',
        formItem: {
          disabled: true,
          initialValue: data && data['surveyTemplateName'] ? data['surveyTemplateName'] : null,
        }
      } : {},
    data.entityRecord ?
      {
        title: "问卷类型",
        name: "questionnaireName",
        formItem: {
          type: 'custom',
          render: (record, form) => {
            let typeName = "";
            if (record && record.type == 0) {
              typeName = "普通问卷"
            } else if (record && record.type == 1) {
              typeName = "随堂问卷"
            } else if (record && record.type == 2) {
              typeName = "回执问卷"
            } else {
              typeName = "满意度问卷"
            }
            return (
              <div>
                {typeName}
              </div>)
          }
        },
      } : {},
    {
      name: 'type',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '问卷时间',
      name: 'classDate',
      formItem: {
        type: "date~",
        showTime: true,
        initialValue: data && data['surveyDate'] ? data['surveyDate'] : null,
        rules: [{
          required: true,
          message: '请选择问卷时间'
        }],
      },
    },
    {
      title: "状态",
      name: "status",
      dict: [
        { code: 0, codeName: "草稿" },
        { code: 1, codeName: "打开" },
        { code: 2, codeName: "关闭" }
      ],
      formItem: {
        type: "radio",
        initialValue: data && data['status'] ? data['status'] : 0
      }
    },
  ]
};
/**
 * 签到
 */
export const columnsSign = (self, data) => [
  {
    name: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    name: 'aideTypeId',
    formItem: {
      type: 'hidden',
      initialValue: data && data['aideTypeId'] ? data['aideTypeId'] : null
    }
  },
  {
    name: 'classId',
    formItem: {
      type: 'hidden',
      initialValue: data && data['classId'] ? data['classId'] : null
    }
  },
  {
    name: 'classAideId',
    formItem: {
      type: 'hidden',
      initialValue: data && data['classAideId'] ? data['classAideId'] : null
    }
  },
  {
    name: 'signTimesId',
    formItem: {
      type: 'hidden',
    }
  },
  {
    title: '名称',
    name: 'name',
    formItem: {
      rules: [{
        required: true,
        message: '请输入名称'
      }, {
        max: 10,
        message: '名称不能超过10个字'
      }
      ],
    }
  },
  {
    title: '签到时间',
    name: 'signDate',
    formItem: {
      type: "date~",
      showTime: true,
      initialValue: data && data['signDate'] ? data['signDate'] : null,
      rules: [{
        required: true,
        message: '请选择签到时间'
      }],
    },
  },
  {
    title: "状态",
    name: "status",
    dict: [
      { code: 0, codeName: "草稿" },
      { code: 1, codeName: "打开" },
      { code: 2, codeName: "关闭" }
    ],
    formItem: {
      type: "radio",
      initialValue: data && data['status'] ? data['status'] : 0
    }
  },
];
/**
 * 考试
 */

export const columnsExam = (self, data) => {

  // 主观题radio
  const _renderContainsSubjective = (form) => {
    let { getFieldValue, getFieldDecorator } = form
    let checkAutoMark = getFieldValue('autoMark')
    return (
      checkAutoMark ?
        getFieldDecorator('containsSubjective', {
          initialValue: data.entityRecord ? data.entityRecord['containsSubjective'] : 1,
        })(
          <WizRadio.Group disabled={!!data.entityRecord}>
            <WizRadio value={1}>包括主观题</WizRadio>
            <WizRadio value={0}>不包括主观题</WizRadio>
          </WizRadio.Group>
        ) : null
    )
  }

  //讲师验证
  let lecturesValidator = (rule, value, callback) => {
    if (value.length === 0) {
      wizNotice.warn('请选择讲师')
      callback('请选择讲师')
    }
    if (value && value.length > 5) {
      wizNotice.warn('讲师最多选择5个')
      callback('讲师最多选择5个')
    }
    callback();
  }

  // 选择讲师
  let _renderTeacherList = (form) => {
    let { getFieldValue, getFieldDecorator, setFieldsValue } = form
    let checkContainsSubjective = getFieldValue('containsSubjective')
    return (
      checkContainsSubjective === 0 ? getFieldDecorator('personIds', {
        initialValue: data.entityRecord ? data.entityRecord['teacherList'].map(e => e.personId) : [],
        rules: [
          {
            validator: lecturesValidator
          },
          { required: true, message: '请选择批阅人' }
        ],
      })(<WizRow type='flex'>
        <WizCol>安排批阅人：</WizCol>
        <WizCol span={18}>
          <WizTableForm
            {...userConfig}
            initRows={data.entityRecord ? data.entityRecord['teacherList'] : []}
            value={data.entityRecord ? data.entityRecord['teacherList'].map(e => e.personId) : []}
            onChange={(e) => { setFieldsValue({ personIds: e }) }}
          ></WizTableForm>
        </WizCol>
      </WizRow>) : null

    )
  }

  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      name: 'examTemplateId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      name: 'aideTypeId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['aideTypeId'] ? data['aideTypeId'] : null
      }
    },
    {
      name: 'classId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['classId'] ? data['classId'] : null
      }
    },
    {
      name: 'classAideId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['classAideId'] ? data['classAideId'] : null
      }
    },
    !data.entityRecord ?
      {
        title: "选择考试模版",
        name: "examId",
        formItem: {
          ...examTempConfig,
          diy: WizTableForm,
          initRows: [],
          selectType: 'radio',
          rules: [{
            required: true,
            message: '请选择考试模版',
          }],
          onChange: (form, value, label, extra) => {
            if (label) {
              self.setState({
                examName: label[0].title
              })
            } else {
              self.setState({
                examName: undefined
              })
            }
          },
        },
      } : {},
    data.entityRecord ?
      {
        title: '选择考试模版',
        name: 'examTemplateName',
        formItem: {
          disabled: true,
          initialValue: data && data['examTemplateName'] ? data['examTemplateName'] : null,
        }
      } : {},
    {
      title: '系统自动批阅',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form
          let tips = '若考试存在主观题需要讲师批阅，请勾选“系统自动批阅”后，选择“不包括主观题”并设置批阅人。成功创建考试后，无法修改批阅方式。'
          return (
            <>
              <div>
                {
                  getFieldDecorator('autoMark', { initialValue: data.entityRecord ? data.entityRecord['autoMark'] : 0 })(
                    <WizCheckbox
                      defaultChecked={data.entityRecord ? data.entityRecord['autoMark'] : 0}
                      disabled={!!data.entityRecord}>
                    </WizCheckbox>
                  )
                }
                <WizTooltip title={tips}>
                  <WizIcon type='question-circle-o' style={{ marginLeft: '10px' }} />
                </WizTooltip>
              </div>
              <div>
                {_renderContainsSubjective(form)}
              </div>
              <div>
                {_renderTeacherList(form)}
              </div>
            </>
          )
        }
      }
    },
    {
      title: '环节名称',
      name: 'name',
      formItem: {
        initialValue: self.state.examName ? self.state.examName : data && data['title'] ? data['title'] : null,
        rules: [{
          required: true,
          message: '请输入环节名称'
        }, {
          max: 30,
          message: '环节名称不能超过30个字'
        }
        ],
      }
    },
    {
      title: '环节时间',
      name: 'classDate',
      formItem: {
        type: "date~",
        showTime: true,
        initialValue: data && data['classDate'] ? data['classDate'] : data.classAideDefaultDate,
        rules: [{
          required: true,
          message: '请选择环节时间'
        }],
      },
    },
    {
      title: "状态",
      name: "status",
      dict: [
        { code: 0, codeName: "打开" },
        { code: 1, codeName: "关闭" }
      ],
      formItem: {
        // type: "radio",
        type: 'hidden',
        initialValue: data && data['status'] ? data['status'] : 0,
      }
    },
    {
      title: "环节阶段",
      name: "stage",
      dict: [
        { code: 0, codeName: "课前" },
        { code: 1, codeName: "课中" },
        { code: 2, codeName: "课后" }
      ],
      formItem: {
        type: "radio",
        initialValue: data && data['stage'] ? data['stage'] : 2,
      }
    },
  ];
}
/**
 * 提问
 */
export const columnsQuestion = (self, data) => [
  {
    name: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    name: 'aideTypeId',
    formItem: {
      type: 'hidden',
      initialValue: data && data['aideTypeId'] ? data['aideTypeId'] : null
    }
  },
  {
    name: 'classId',
    formItem: {
      type: 'hidden',
      initialValue: data && data['classId'] ? data['classId'] : null
    }
  },
  {
    name: 'classAideId',
    formItem: {
      type: 'hidden',
      initialValue: data && data['classAideId'] ? data['classAideId'] : null
    }
  },
  {
    title: '环节名称',
    name: 'name',
    formItem: {
      rules: [{
        required: true,
        message: '请输入环节名称'
      }, {
        max: 30,
        message: '环节名称不能超过30个字'
      }
      ],
    }
  },
];

/**
 * 作业
 */
export const columnsHomework = (self, data) => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      name: 'examTemplateId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      name: 'aideTypeId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['aideTypeId'] ? data['aideTypeId'] : null
      }
    },
    {
      name: 'classId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['classId'] ? data['classId'] : null
      }
    },
    {
      name: 'classAideId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['classAideId'] ? data['classAideId'] : null
      }
    },
    !data.entityRecord ?
      {
        title: "作业内容",
        name: "homeworkId",
        formItem: {
          ...homeworkConfig,
          diy: WizTableForm,
          initRows: [],
          selectType: 'radio',
          rules: [{
            required: true,
            message: '作业内容',
          }],
          onChange: (form, value, label, extra) => {
            if (label) {
              self.setState({
                homeworkDate: label[0].startDate + '~' + label[0].endDate,
                homeworkName: label[0].name
              })
            } else {
              self.setState({
                homeworkDate: undefined,
                homeworkName: undefined
              })
            }
          },
        },
      } : {},
    data.entityRecord ?
      {
        title: '作业内容',
        name: 'name',
        formItem: {
          disabled: true,
          initialValue: data && data['entityRecord'] ? data['entityRecord']['name'] : null,
        }
      } : {},
    {
      title: '环节名称',
      name: 'aideName',
      formItem: {
        initialValue: self.state.homeworkName ? self.state.homeworkName : data && data['entityRecord'] ? data['entityRecord']['aideName'] : null,
        rules: [{
          required: true,
          message: '请输入环节名称'
        }, {
          max: 30,
          message: '环节名称不能超过30个字'
        }
        ],
      }
    },
    {
      title: "作业时间",
      name: "homeworkDate",
      formItem: {
        type: 'custom',
        render: (record) => {
          return <div>{record ? record['startDate'] + '~' + record['endDate'] : self.state.homeworkDate}</div>
        }
      },
    },
    {
      title: '环节时间',
      name: 'classDate',
      formItem: {
        type: "date~",
        showTime: true,
        initialValue: data && data['classDate'] ? data['classDate'] : data.classAideDefaultDate,
        rules: [{
          required: true,
          message: '请选择环节时间'
        }],
      },
    },
    {
      title: "状态",
      name: "status",
      dict: [
        { code: 0, codeName: "打开" },
        { code: 1, codeName: "关闭" }
      ],
      formItem: {
        // type: "radio",
        type: 'hidden',
        initialValue: data && data['status'] ? data['status'] : 0,
      }
    },
    {
      title: "环节阶段",
      name: "stage",
      dict: [
        { code: 0, codeName: "课前" },
        { code: 1, codeName: "课中" },
        { code: 2, codeName: "课后" }
      ],
      formItem: {
        type: "radio",
        initialValue: data && data['stage'] ? data['stage'] : 0,
      }
    },
  ]
};


/**
 * 满意度问卷
 */
export const columnsSatisfaction = (self, data) => {
  self.surveyType = 3;
  const surveyTempConfig = WizTableForm.Config.surveyTemp(self, { apiParams: { status: 1, type: 3 } })

  let appLabel = data.labelInfo || []
  const appOption = appLabel.map(app =>

    <OptGroup label={app['labelName']}>
      {app.optionList && app.optionList instanceof Array && app.optionList.length > 0 ?
        app.optionList.map(option =>
          <Option value={option.optionValue}>{option.optionName}</Option>)
        : null
      }
    </OptGroup>)
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      name: 'aideTypeId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['aideTypeId'] ? data['aideTypeId'] : null
      }
    },
    {
      name: 'classId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['classId'] ? data['classId'] : null
      }
    },
    {
      name: 'classAideId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['classAideId'] ? data['classAideId'] : null
      }
    },
    !data.entityRecord ?
      {
        title: "选择问卷模版",
        name: "questionnaireId",
        formItem: {
          ...surveyTempConfig,
          diy: WizTableForm,
          initRows: [],
          selectType: 'radio',
          rules: [{
            required: true,
            message: '请选择问卷模版',
          }],
          onChange: (form, value, label, extra) => {
            if (label) {
              self.setState({
                satisfactionName: label[0].title
              })
            } else {
              self.setState({
                satisfactionName: undefined
              })
            }
          },
        },
      } : {},
    data.entityRecord ?
      {
        title: '选择问卷模版',
        name: 'surveyTemplateName',
        formItem: {
          disabled: true,
          initialValue: data && data['surveyTemplateName'] ? data['surveyTemplateName'] : null,
        }
      } : {},
    {
      title: '环节名称',
      name: 'aideName',
      formItem: {
        initialValue: self.state.satisfactionName ? self.state.satisfactionName : data && data['entityRecord'] ? data['entityRecord']['aideName'] : null,
        rules: [{
          required: true,
          message: '请输入环节名称'
        }, {
          max: 30,
          message: '环节名称不能超过30个字'
        }
        ],
      }
    },
    {
      name: 'type',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '环节时间',
      name: 'classDate',
      formItem: {
        type: "date~",
        showTime: true,
        initialValue: data && data['classDate'] ? data['classDate'] : data.classAideDefaultDate,
        rules: [{
          required: true,
          message: '请选择环节时间'
        }],
      },
    },
    {
      title: "推送企业号",
      name: "pushEnterpriseNumber",
      dict: [
        { code: 1, codeName: "是" },
        { code: 0, codeName: "否" }
      ],
      formItem: {
        type: "radio",
        initialValue: data && data['pushEnterpriseNumber'] ? data['pushEnterpriseNumber'] : 0,
      }
    },
    {
      title: "选择应用",
      name: "appIds",
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator, getFieldValue } = form
          if (getFieldValue("pushEnterpriseNumber")) {
            return (
              <>
                {getFieldDecorator('appIds', {
                  initialValue: data?.entityRecord?.appIds || [],
                  rules: [{ required: true, message: '请选择选择应用' }],
                })(

                  <WizSelect
                    placeholder="请选择选择应用"
                    mode="multiple"
                  // onChange={(appIds) => { this.setState({ appIds }) }}
                  >
                    {appOption}
                  </WizSelect>,
                )}
              </>
            )
          } else {
            return (<></>)
          }
        }
      }
    },
    {
      title: "状态",
      name: "status",
      dict: [
        { code: 0, codeName: "打开" },
        { code: 1, codeName: "关闭" }
      ],
      formItem: {
        // type: "radio",
        type: 'hidden',
        initialValue: data && data['status'] ? data['status'] : 0,
      }
    },
    {
      title: "环节阶段",
      name: "stage",
      dict: [
        { code: 0, codeName: "课前" },
        { code: 1, codeName: "课中" },
        { code: 2, codeName: "课后" }
      ],
      formItem: {
        type: "radio",
        initialValue: data && data['stage'] ? data['stage'] : 2,
      }
    },
  ]
};


/**
 * 远程认证
 */
export const columnsRemoteAuth = (self, data) => {
  const { remoteAuthIdList, id } = data;
  const remoteAuth = WizTableForm.Config.remoteAuth(this, { apiParams: { ninIdList: remoteAuthIdList, type: 0 } });
  let columnsPart1 = [
    {
      name: 'aideTypeId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['aideTypeId'] ? data['aideTypeId'] : null
      }
    },
    {
      name: 'classId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['classId'] ? data['classId'] : null
      }
    },
    {
      name: 'classAideId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['classAideId'] ? data['classAideId'] : null
      }
    },
    {
      name: 'remoteAuthId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '环节名称',
      name: 'aideName',
      formItem: {
        initialValue: data && data['aideName'] ? data['aideName'] : null,
        placeholder: '默认班级名称',
        rules: [{
          required: true,
          message: '请输入环节名称'
        }, {
          max: 30,
          message: '环节名称不能超过30个字'
        }
        ],
      }
    }];
  let columnsPart2 = [
    {
      title: '环节时间',
      name: 'classDate',
      formItem: {
        type: "date~",
        showTime: true,
        initialValue: data && data['classDate'] ? data['classDate'] : data.classAideDefaultDate,
        rules: [{
          required: true,
          message: '请选择环节时间'
        }],
      },
    },
    {
      title: "状态",
      name: "status",
      dict: [
        { code: 0, codeName: "打开" },
        { code: 1, codeName: "关闭" }
      ],
      formItem: {
        // type: "radio",
        type: 'hidden',
        initialValue: data && data['status'] ? data['status'] : 0,
      }
    },
    {
      title: "环节阶段",
      name: "stage",
      dict: [
        { code: 0, codeName: "课前" },
        { code: 1, codeName: "课中" },
        { code: 2, codeName: "课后" }
      ],
      formItem: {
        type: "radio",
        initialValue: data && data['stage'] ? data['stage'] : 1,
      }
    }
  ];
  let columnsRemoteAuth = [
    {
      title: "认证项目",
      name: "id",
      formItem: {
        ...remoteAuth,
        diy: WizTableForm,
        initialValue: data && data['id'] ? data['id'] : '',
        initRows: data && data['id'] && data['name'] ? [{ key: '1', id: data['id'], name: data['name'] }] : [],
        selectType: 'radio',
        disabled: data && data['id'] ? true : false,
        rules: [{ required: true, message: '请选择认证项目' }],
      },
    }
  ]
  return [...columnsPart1, ...columnsRemoteAuth, ...columnsPart2]
};

/**
 * NEV认证
 */
 export const columnsNEVLive = (self, data) => {
  const { remoteAuthIdList, id } = data;
  const remoteAuth = WizTableForm.Config.remoteAuth(this, { apiParams: {
    // ninIdList: remoteAuthIdList,
     type: 2
    } });
  let columnsPart1 = [
    {
      name: 'aideTypeId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['aideTypeId'] ? data['aideTypeId'] : null
      }
    },
    {
      name: 'classId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['classId'] ? data['classId'] : null
      }
    },
    {
      name: 'classAideId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['classAideId'] ? data['classAideId'] : null
      }
    },
    {
      name: 'remoteAuthId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '环节名称',
      name: 'aideName',
      formItem: {
        initialValue: data && data['aideName'] ? data['aideName'] : null,
        placeholder: '默认班级名称',
        rules: [{
          required: true,
          message: '请输入环节名称'
        }, {
          max: 20,
          message: '环节名称不能超过20个字'
        }
        ],
      }
    }];
  let columnsPart2 = [
    {
      title: '环节时间',
      name: 'classDate',
      formItem: {
        type: "date~",
        showTime: true,
        initialValue: data && data['classDate'] ? data['classDate'] : data.classAideDefaultDate,
        rules: [{
          required: true,
          message: '请选择环节时间'
        }],
      },
    },
    {
      title: "状态",
      name: "status",
      dict: [
        { code: 0, codeName: "打开" },
        { code: 1, codeName: "关闭" }
      ],
      formItem: {
        // type: "radio",
        type: 'hidden',
        initialValue: data && data['status'] ? data['status'] : 0,
      }
    },
    {
      title: "环节阶段",
      name: "stage",
      dict: [
        { code: 0, codeName: "课前" },
        { code: 1, codeName: "课中" },
        { code: 2, codeName: "课后" }
      ],
      formItem: {
        type: "radio",
        initialValue: data && data['stage'] ? data['stage'] : 1,
      }
    }
  ];
  let columnsRemoteAuth = [
    {
      title: "认证项目",
      name: "id",
      formItem: {
        ...remoteAuth,
        diy: WizTableForm,
        initialValue: data && data['id'] ? data['id'] : '',
        initRows: data && data['id'] && data['name'] ? [{ key: '1', id: data['id'], name: data['name'] }] : [],
        selectType: 'radio',
        disabled: data && data['id'] ? true : false,
        rules: [{ required: true, message: '请选择认证项目' }],
      },
    }
  ]
  return [...columnsPart1, ...columnsRemoteAuth, ...columnsPart2]
};

/**
 * NEVMeeting
 */
 export const columnsNEVMeeting = (self, data) => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      name: 'ownerId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      name: 'personIds',
      formItem: {
        type: 'hidden',
        initialValue: data && data['personIds'] ? data['personIds'] : null
      }
    },
    {
      name: 'aideTypeId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['aideTypeId'] ? data['aideTypeId'] : null
      }
    },
    {
      name: 'classId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['classId'] ? data['classId'] : null
      }
    },
    {
      name: 'classAideId',
      formItem: {
        type: 'hidden',
        initialValue: data && data['classAideId'] ? data['classAideId'] : null
      }
    },
    {
      title: '直播类型',
      name: 'liveType',
      formItem: {
        type: 'hidden',
        initialValue: data && data['liveType'] ? data['liveType'] : null
      }
    },
    {
      title: "状态",
      name: "state",
      dict: [
        { code: 1, codeName: "草稿" },
        { code: 2, codeName: "预告中" },
        { code: 3, codeName: "直播中" },
        { code: 4, codeName: "已结束" }
      ],
      formItem: {
        type: 'hidden',
        initialValue: data && data['state'] ? data['state'] : 1,
      }
    },
    {
      title: '环节名称',
      name: 'name',
      formItem: {
        initialValue: data && data['name'] ? data['name'] : null,
        placeholder: '默认班级名称',
        rules: [{
          required: true,
          message: '请输入环节名称'
        }, {
          max: 30,
          message: '环节名称不能超过30个字'
        }
        ],
      }
    },
    {
      title: '直播分类',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form;
          let categoryInfo;
          if (record && record.liveCategoryId && record.categoryName) {
            categoryInfo = [{ key: record.liveCategoryId, title: record.categoryName }]
          }
          return (
            <div>
              {getFieldDecorator('liveCategoryId', {
                rules: [{ type: 'array' }, { required: true, message: '请选择直播分类' }],
                initialValue: record && record.liveCategoryId ? [record.liveCategoryId] : [],
              })(
                <WizClassifySelectRe
                  returnKey={true}
                  apiProps={{ type: 9, state: 1 }}
                  initSelects={categoryInfo ? categoryInfo : []}
                  wizTreeSelectListProps={{
                    itemProps: {
                      icon: 'unordered-list',
                      title: '直播分类',
                      tips: '请选择直播分类'
                    },
                    multiple: false,
                    treeCheckable: false,
                    checkable: false,
                    showSelectList: true,
                    treeProps: { checkStrictly: true }
                  }} />
              )}
            </div>
          );
        }
      }
    },
    {
      title: "讲师",
      name: "hostId",
      formItem: {
        ...userNevConfig,
        diy: WizTableForm,
        initialValue: data && data['hostId'] ? data['hostId'] : '',
        title: "选择讲师",
        initRows: data && data['hostId'] && data['hostName'] ? [{
          key: '1',
          personId: data['hostId'],
          fullName: data['hostName'],
          id: data['hostId']
        }] : [],
        selectType: 'radio',
        rules: [{ required: true, message: '请选择讲师' }],
      },
    },
    {
      title: '环节时间',
      name: 'classDate',
      formItem: {
        type: "date~",
        showTime: true,
       // initialValue: data && data['classDate'] ? data['classDate'] : data.classAideDefaultDate,
        rules: [{
          required: true,
          message: '请选择环节时间'
        }],
        disabled: data && data['state'] && data['state'] !== 1,
        onChange: (form, value, label, extra) => {
          if (label && label.length > 0) {
            let startDate = label[0];
            let endDate = label[1];
            // type ： 0:zoom资源帐户；1：中目 远程评估资源帐户    2: 中目 直播课堂 远程认证
            // liveType： 5 直播课堂 6远程评估
            let type = data.liveType === 5 ? 2 : 1;
            let meetingNo = data.ownerId;
            self.checkMeetingDate(startDate, endDate, meetingNo, type)
          }
        },
      },
    },
    // self.state.checkDateInfo ?
    //   {
    //     title: <font style={{ 'color': 'red' }}>提醒</font>,
    //     name: "checkDateInfo",
    //     formItem: {
    //       type: self.state.checkDateInfo ? 'diy' : 'hidden',
    //       diy: () => {
    //         return (
    //           <div style={{ 'color': 'red' }}>{self.state.checkDateInfo}</div>
    //         )
    //       }
    //     },
    //   } : {},
    {
      title: '上传封面',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const { getFieldDecorator } = form;
          return (
            <div style={{ width: 400 }}>
              <>
                {getFieldDecorator('img', {
                  initialValue: (data && data.img) ? [
                    { fileId: data.img }
                  ] : [],
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={400 / 207}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 0.195;
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过200k!');
                      }
                      return isLt1M;
                    }}
                  />
                )}
              </>
            </div>
          )
        }
      }
    },
    {
      title: "状态",
      name: "status",
      dict: [
        { code: 0, codeName: "打开" },
        { code: 1, codeName: "关闭" }
      ],
      formItem: {
        // type: "radio",
        type: 'hidden',
        initialValue: data && data['status'] ? data['status'] : 0,
      }
    },
    {
      title: "环节阶段",
      name: "stage",
      dict: [
        { code: 0, codeName: "课前" },
        { code: 1, codeName: "课中" },
        { code: 2, codeName: "课后" }
      ],
      formItem: {
        type: "radio",
        initialValue: data && data['stage'] ? data['stage'] : 1,
      }
    },
  ]
};
